import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gfu-sidenav__content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_toggle_trigger = _resolveComponent("toggle-trigger")
  const _component_side_nav_link = _resolveComponent("side-nav-link")
  const _component_toggle_content = _resolveComponent("toggle-content")
  const _component_toggle_container = _resolveComponent("toggle-container")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_side_nav_container = _resolveComponent("side-nav-container")

  return (_ctx.projectContext.project)
    ? (_openBlock(), _createBlock(_component_side_nav_container, {
        key: 0,
        title: "Project settings",
        icon: "cog"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.links, (link, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (link.subItems.length > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: `containerToggle:${link.navigationItemId}`
                  }, [
                    _createVNode(_component_toggle_container, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_toggle_trigger, {
                          tag: "div",
                          "auto-collapse": false,
                          class: "gfu-sidenav__item gfu-sidenav__trigger",
                          "active-class": "gfu-sidenav__trigger--expanded",
                          "data-qa": `admin-project-sidenav-trigger:${link.qa}`
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, _toDisplayString(link.label), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["data-qa"]),
                        _createVNode(_component_toggle_content, {
                          ref_for: true,
                          ref: `containerToggle:${link.navigationItemId}`,
                          "show-expanded": link.isExpanded,
                          tag: "div",
                          class: "gfu-sidenav__collapsible",
                          "active-class": "gfu-sidenav__collapsible--expanded",
                          tabindex: index
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.subItems, (child) => {
                              return (_openBlock(), _createBlock(_component_side_nav_link, {
                                key: child.label,
                                to: child.to,
                                icon: child.iconName,
                                "data-qa": `admin-project-sidenav-link:${child.qa}`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(child.label), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "icon", "data-qa"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show-expanded", "tabindex"])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]))
                : (_openBlock(), _createBlock(_component_side_nav_link, {
                    key: link.navigationItemId,
                    to: link.to,
                    icon: link.icon.name,
                    "icon-namespace": link.icon.namespace,
                    "data-qa": `admin-project-sidenav-link:${link.qa}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(link.label), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "icon", "icon-namespace", "data-qa"]))
            ], 64 /* STABLE_FRAGMENT */))
          }), 256 /* UNKEYED_FRAGMENT */)),
          _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
        ]),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}